/* MATERIAL UI PALETTE COLORS */
export const MAIN_COLOR = '#FF826E'
export const SECONDARY_COLOR = '#F7F7F7'

/* PROJECT COLORS */
export const FULL_WHITE = '#FFFFFF'
export const NEUTRAL_BLACK = '#5C0031'
export const NEUTRAL_WHITE = '#FCFDFD'
export const NEUTRAL_DARK = '#1D2021'
export const GREY_10_COLOR = '#F7F7F7'
export const GREY_20_COLOR = '#EAEDED'
export const GREY_50_COLOR = '#384245'

export const BACKGROUND_COLOR = '#E5E5E5'
